<div class="edit-mood-box mb-3">
    <span  (click)="cancelUpdate()">
        <span class="comment-card-cancel"><i class="far fa-times"></i></span>
    </span>

  <div class="card-comment">
          <textarea id="topic-textarea-to-edit"
                    class="card-comment-body mood-textarea-to-edit"
                    name="topicTitle"
                    [formControl]='topicCommentCtrl'
                    [attr.placeholder]="topicPlaceholder | translate"></textarea>

            <tm-mood-pickers (onElement)="fromMoodPicker($event)"></tm-mood-pickers>

    <div class="timeline-item-to-edit-actions">
        <button (click)="saveUpdate()" class="btn btn-sm btn-outline-secondary"
                [disabled]="topic.title.body?.length === 0">
            {{'save' | translate}} <i class="far fa-check"></i>
        </button>
    </div>
  </div>
</div>

